import Carousel from "../../Tools/Carousel";
import useCart from "../utils/useCart";
import RewardCard from "./RewardCard";
import useRewards from "../utils/useRewards";

export default function RewardsCarousel(){

    const query = useRewards()

    const { cart, setCart } = useCart()


    return query.isSuccess &&

        <Carousel 
            items={query.data}
            itemsPerPage={itemsPerPage()} 
            renderItem={item => 
                <RewardCard
                    item={item}
                    disabled={item.id === cart.reward}
                    key={item.id}
                />
            }
            selected={cart.reward ? query.data.find(i => i.id === cart.reward) : null}
            onDeselect={() => setCart({ reward: null })}
        />
}

function itemsPerPage(){

    let w = window.innerWidth;

    if(w > 1400) return 3;

    if(w > 1000) return 2;

    return 1;
}